var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInActiveCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80328 1V3.25M15.3868 1V3.25M1.02344 16.75V5.5C1.02344 4.90326 1.26238 4.33097 1.68769 3.90901C2.11301 3.48705 2.68986 3.25 3.29134 3.25H16.8988C17.5003 3.25 18.0771 3.48705 18.5024 3.90901C18.9277 4.33097 19.1667 4.90326 19.1667 5.5V16.75M1.02344 16.75C1.02344 17.3467 1.26238 17.919 1.68769 18.341C2.11301 18.7629 2.68986 19 3.29134 19H16.8988C17.5003 19 18.0771 18.7629 18.5024 18.341C18.9277 17.919 19.1667 17.3467 19.1667 16.75M1.02344 16.75V9.25C1.02344 8.65326 1.26238 8.08097 1.68769 7.65901C2.11301 7.23705 2.68986 7 3.29134 7H16.8988C17.5003 7 18.0771 7.23705 18.5024 7.65901C18.9277 8.08097 19.1667 8.65326 19.1667 9.25V16.75",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveCalendarIcon);
export default __webpack_public_path__ + "static/media/InActiveCalendarIcon.0575f6b13b019b95b347136d3df0c1f3.svg";
export { ForwardRef as ReactComponent };